import React from 'react';

import whiteImgPath from './assets/jetstyle-white.svg';
import blackImgPath from './assets/jetstyle-black.svg';

import './JetLogo.scss';

const JetLogo = (props) => {
  const { color } = props;
  const { langs } = window;

  function choiseLogo(color) {
    switch(color) {
      case 'white':
        return whiteImgPath;

      case 'black':
        return blackImgPath;

      default:
        return blackImgPath;
    }
  }

  return (
    <div className="jet-logo">
      <a href={ langs.jetStyleLink } target="_blank" rel="noopener noreferrer">
        <img src={ choiseLogo(color) } alt="" className="jet-logo__img"/>
      </a>
    </div>
  )
}

export default JetLogo;


// WEBPACK FOOTER //
// ./src/components/JetLogo/JetLogo.js